import axios from 'axios';
import { getEnvValue } from './getEnvValue';
import { AxiosErrorResponse, ErrorResponse } from './types';

const isDefaultAxiosError = (error: ErrorResponse): error is AxiosErrorResponse => {
  return 'message' in error;
};

const logError = (error: ErrorResponse) => {
  if (getEnvValue('NODE_ENV').toLocaleUpperCase() !== 'DEVELOPMENT') {
    return;
  }

  console.info(`%cSTATUS CODE: ${error.statusCode}`, 'color: red');
  if (isDefaultAxiosError(error)) {
    if (error.errorCode) {
      console.info(`%cERROR CODE: ${error.errorCode}`, 'color: red');
    }
    console.info(`PATH: ${error.path}`);
    console.info(`MESSAGE FROM BACKEND: ${error.message}`);
    console.info(`REQUEST ID: ${error.requestId}`);

    if (error.context) {
      console.info(`CONTEXT: ${error.context}`);
    }
    if (error.stack) {
      console.info(`STACK: ${error.stack}`);
    }
  }
};

const isStaticErrorStatusCode = (statusCode: number) => {
  return [401, 403, 404, 500].includes(statusCode);
};

export const getErrorCode = (error: ErrorResponse) => {
  if (isDefaultAxiosError(error) && error.errorCode) {
    return error.errorCode;
  }

  if (isStaticErrorStatusCode(error.statusCode)) {
    return error.statusCode;
  }

  return 500;
};

export const errorHandler = (error: unknown): ErrorResponse => {
  const somethingWentWrongError = { statusCode: 500 };

  if (axios.isAxiosError(error)) {
    if (error.response) {
      logError(error.response.data);
      return error.response.data;
    }

    logError(somethingWentWrongError);
    return somethingWentWrongError;
  }

  logError(somethingWentWrongError);
  return somethingWentWrongError;
};
